import React from 'react';
interface ArticleCardProps {
  imageUrl?: string;
  title?: string;
  description?: string;
  category?: string;
  hasShadow?: boolean;
  index?: number;
  whiteBorder?: boolean;
}
export function ArticleCard({
  imageUrl,
  title = 'The US agencies storming up the World Creative Rankings',
  description = "Special Group, a global independent creative network, was the year's biggest climber in North America.",
  category = 'NEWS',
  hasShadow = false,
  whiteBorder = false
}: ArticleCardProps) {
  const hasImage = imageUrl && imageUrl !== '#D9D9D9';
  return <div className="flex flex-col group cursor-pointer w-full" data-id="element-20">
      <div className="has-radius w-full relative overflow-hidden" style={{
      aspectRatio: '430/225',
      backgroundColor: 'lightgray',
      borderRadius: '18.75px 0',
      border: whiteBorder ? '3px solid #FFF' : undefined
    }} data-id="element-21">
        {hasImage && <img src={imageUrl} alt={title} className="absolute inset-0 w-full h-full object-cover scale-[1.03] group-hover:scale-110 transition-transform duration-500" data-id="element-22" />}
      </div>
      {/* Title + description below image */}
      <div style={{
      marginTop: '14px'
    }} data-id="element-23">
        <h3 style={{
        color: '#090909',
        fontFamily: "'League Gothic', Impact, Arial, sans-serif",
        fontSize: '30px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '32px'
      }} data-id="element-24">
          {title}
        </h3>
        <p className="line-clamp-3 mt-2" style={{
        color: '#090909',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 'normal'
      }} data-id="element-25">
          {description}
        </p>
      </div>
      <div style={{
      marginTop: '15px'
    }} data-id="element-26">
        <span className="has-radius inline-flex items-center justify-center uppercase cursor-pointer transition-colors duration-200 hover:bg-gray-50" style={{
        border: '0.75px solid #6B6B6B',
        borderRadius: '18.75px',
        height: '19px',
        paddingLeft: '8px',
        paddingRight: '8px',
        color: '#090909',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '11.25px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: 'normal'
      }} data-id="element-27">
          {category}
        </span>
      </div>
    </div>;
}